module.exports = __webpack_public_path__ + "fd65e403e8a68838090a177d8da9ce8e.svg";